import { BaseField } from "./base";

export class CalculatorField extends BaseField {
	constructor(field, form) {
		super(field, form);
		this.updaters = [];
	}

	init() {
		this.calculatorOptions = JSON.parse(
			this.field.dataset.calculatorOptions || "{}",
		);

		if (this.calculatorOptions.hide) {
			this.field.closest(".form-group").style.display = "none";
		}

		this.setupCalculator();
		this.form.addEventListener("input", () => {
			this.updaters.forEach((u) => u());
		});
	}

	setupCalculator() {
		let expr = this.field.dataset.calculatorExpression;
		if (expr === "") {
			this.showError(
				"You need to define an expression for the calculator",
			);
			return;
		}

		let evalExpr;
		try {
			expr = atob(expr);
			evalExpr = new Function("form", "form_raw", `return ${expr};`);
		} catch (e) {
			this.showError(e);
			return;
		}

		const updater = () => {
			const fd = new FormData(this.form);
			const formProxy = new Proxy(
				{ type: "numeric", data: fd },
				this.proxyHandler,
			);
			const formRawProxy = new Proxy(
				{ type: "raw", data: fd },
				this.proxyHandler,
			);
			try {
				this.field.value = evalExpr(formProxy, formRawProxy);
			} catch (e) {
				this.showError(e);
			}
		};

		updater();
		this.updaters.push(updater);
	}

	showError(msg) {
		this.field.value = `Calculator field: ${msg}`;
		this.field.style.color = "red";
	}

	proxyHandler = {
		get(target, prop, _) {
			const formData = target.data;
			const type = target.type;
			if (formData.has(prop)) {
				let res = formData.get(prop);
				if (type === "numeric") {
					res = parseFloat(res);
					res = isNaN(res) ? 0 : res;
				}
				return res;
			} else {
				throw `Couldn't find field "${prop}", make sure to give the same "name" attribute to the field you want.`;
			}
		},
	};
}
